// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { OpenpayPlan } from "../flow/types";

export default function (
    state: OpenpayPlan = initialState.openpayPlan,
  action: any
) {
    switch (action.type) {
        case ActionTypes.SAVE_OPENPAY_PLAN + ActionTypes.FULFILLED:
            return action.payload;
        case ActionTypes.RESET_OPENPAY_PLAN + ActionTypes.FULFILLED:
            return initialState.openpayPlan;
            
    default:
      return state;
  }
}
